var privateProps = /* @__PURE__ */new WeakMap();

function getPrivate(instance) {
  var _privateProps$get;

  return (_privateProps$get = privateProps.get(instance)) !== null && _privateProps$get !== void 0 ? _privateProps$get : setPrivate(instance, {});
}

function setPrivate(instance, props) {
  var saved = privateProps.get(instance);
  if (!saved) privateProps.set(instance, saved = {});
  return Object.assign(saved, props);
}

export { getPrivate, setPrivate };